<template>
    <v-dialog v-model="dialog" @click:outside="clearForm" max-width="576">
        <v-card class="pa-6 rounded-sm">
            <h6 class="text-h6 primaryDark--text">Отправить по WhatsApp</h6>
            <v-divider class="my-4" />
            <v-form ref="form" @submit.prevent="sendWhatsAppMsg">
                <div style="color: #666666">Выберите номер телефона из списка контактов или введите вручную</div>
                <v-radio-group row v-model="selectPhoneType">
                    <v-radio color="gray" v-for="(phoneType, idx) of phoneTypes" :key="idx" :label="phoneType.label" :value="phoneType.value"></v-radio>
                </v-radio-group>
                <v-row>
                    <v-col>
                        <v-text-field
                            v-if="selectPhoneType === 'enter'"
                            v-maska:[maskaOptions]="phone"
                            v-model="phoneNumber"
                            hide-details="auto"
                            outlined
                            :rules="[validationRules.phone]"
                            color="primaryDark"
                            placeholder="+7 (XXX) XXX XX XX"
                            label="Контактный номер телефона "
                            validate-on-blur
                        />
                        <v-select
                            :attach="true"
                            v-else
                            hide-details
                            outlined
                            color="primaryDark"
                            label="Выберите контактный номер телефона "
                            v-model="phoneNumber"
                            :items="contacts"
                            item-text="contact_value"
                            item-value="contact_value"
                        />
                    </v-col>
                </v-row>
                <div class="d-flex justify-end">
                    <v-btn @click="closeDialog" rounded class="mr-4" outlined color="gray">Отмена</v-btn>
                    <v-btn type="submit" rounded color="gray" class="white--text">Отправить</v-btn>
                </div>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { validationRules } from '@/utils/validationRules';
import { mask } from '@/main';
import { maskaOptions } from '@/utils';
export default {
    name: 'WhatsAppDialog',
    props: ['msg'],
    data: function() {
        return {
            dialog: false,
            phoneNumber: null,
            phone: {
                masked: '',
                unmasked: '',
                completed: false
            },
            phoneTypes: [
                {
                    value: 'choose',
                    label: 'Выбрать из списка'
                },
                {
                    value: 'enter',
                    label: 'Ввод вручную'
                }
            ],
            contacts: [],
            selectPhoneType: 'enter',
            moduleName: '',
            guid: '',
            maskaOptions: maskaOptions(this)
        };
    },
    computed: {
        validationRules() {
            return validationRules;
        },
        isFormValid() {
            return this.$refs.form.validate();
        }
    },
    methods: {
        sendWhatsApp(guid, moduleName, contacts) {
            this.guid = guid;
            this.moduleName = moduleName;
            this.contacts = contacts;
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
            this.clearForm();
        },
        sendWhatsAppMsg() {
            if (!this.isFormValid) return;
            const docURL = `${process.env.VUE_APP_URL}/api/${this.moduleName}?guid=${this.guid}`;
            const whatsAppUrl = `https://wa.me/${mask.unmasked(this.phoneNumber)}?text=${docURL}`;
            window.open(whatsAppUrl);
            this.closeDialog();
        },
        clearForm() {
            this.$refs.form.resetValidation();
            this.phoneNumber = null;
        }
    },
    watch: {
        selectPhoneType() {
            this.phoneNumber = null;
        }
    }
};
</script>

<style scoped></style>
